export const scores = {
  GOOD: ['Good', 'جيد'],
  NEUTRAL: ['Neutral', 'معتدل'],
  BAD: ['Bad', 'سيئ'],
};
